var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5654 4.64429V19.1775C18.5772 19.2351 18.5833 19.2947 18.5833 19.3557C18.5833 19.8482 18.1815 20.25 17.689 20.25H5.64429C5.15184 20.25 4.75 19.8482 4.75 19.3557V4.64429C4.75 4.15184 5.15184 3.75 5.64429 3.75H17.6711C18.1635 3.75 18.5654 4.15183 18.5654 4.64429ZM16.7769 5.53861V18.4614H6.53857V5.53861H16.7769ZM8.86575 7.5084C8.37331 7.5084 7.97146 7.91024 7.97146 8.40268C7.97146 8.89513 8.37335 9.29697 8.86575 9.29697H14.6644C15.1568 9.29697 15.5587 8.89512 15.5587 8.40268C15.5587 7.91024 15.1568 7.5084 14.6644 7.5084H8.86575ZM8.86575 11.052C8.37331 11.052 7.97146 11.4539 7.97146 11.9463C7.97146 12.4387 8.37331 12.8406 8.86575 12.8406H14.6644C15.1569 12.8406 15.5587 12.4388 15.5587 11.9463C15.5587 11.4539 15.1569 11.052 14.6644 11.052H8.86575ZM8.86575 14.4883C8.37331 14.4883 7.97146 14.8901 7.97146 15.3825C7.97146 15.875 8.37331 16.2768 8.86575 16.2768H10.5839C11.0763 16.2768 11.4782 15.875 11.4782 15.3825C11.4782 14.8901 11.0763 14.4883 10.5839 14.4883H8.86575Z",
    fill: "#005993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnForm);
export default __webpack_public_path__ + "static/media/on_form.65551bdb98015a1d697e0698d1c3dcaa.svg";
export { ForwardRef as ReactComponent };